// Length limits for a DOCTOR's own fields — ONE source for the two screens that
// edit them: AddDoctor (creation) and DoctorProfileTab (the profile). They used
// to hold two rulers (name 20 / description 500 there, 25 / 100 here), so the
// same record was valid on one screen and refused on the other (P47, owner
// decision 15 Sep 2026).
//
// NAME / SURNAME: Backend/utils/personFields.js NAME_MAX — the server's person
// rule. DESCRIPTION: 500, the owner's figure.
//
// Deliberately NOT in personFields.js: that file is mirrored byte-for-byte into
// the Super Admin SPA (src/test/mirroredFiles.test.js), which has no doctor
// forms of its own.
export const DOCTOR_NAME_MAX_LENGTH = 20;
export const DOCTOR_DESCRIPTION_MAX_LENGTH = 500;
